
import React from 'react';
// import { Link } from 'react-router-dom';
import { Briefcase, Users, Heart, Zap, ArrowRight } from 'lucide-react';
import FadeIn from '../components/FadeIn';
import SEO from '../components/SEO';

const Careers = () => {
    return (
        <div className="bg-white">
            <SEO
                pageKey="careers"
                defaultTitle="Careers at BPO Consultants | Join Our Team"
                defaultDescription="Build the future of AI-augmented outsourcing. Explore career opportunities with BPO Consultants Philippines."
                defaultSchema={JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": "Careers at BPO Consultants",
                    "description": "Join our team and build the future of AI-augmented outsourcing.",
                    "url": "https://bpoconsultants.ph/careers"
                }, null, 4)}
            />

            {/* Hero */}
            <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-[#0B0D15] overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=1200" alt="Teamwork" className="w-full h-full object-cover" />
                </div>
                <div className="max-w-7xl mx-auto relative z-10 text-center">
                    <FadeIn>
                        <span className="inline-block bg-[#A2CB52]/20 text-[#A2CB52] px-4 py-2 rounded-full text-sm font-bold border border-[#A2CB52]/40 mb-6 backdrop-blur-sm">
                            <Briefcase size={14} className="inline mr-1" /> We're Hiring
                        </span>
                        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
                            Build the Future of <br /> <span className="text-[#A2CB52]">AI-Augmented Work</span>
                        </h1>
                        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                            Join a team that's redefining the BPO industry. We combine human empathy with machine intelligence to deliver world-class experiences.
                        </p>
                    </FadeIn>
                </div>
            </section>

            {/* Values Section */}
            <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <FadeIn>
                            <h2 className="text-3xl font-bold text-[#20222D]">Why Join Us?</h2>
                            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">It's not just a job. It's a career accelerator.</p>
                        </FadeIn>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                icon: <Users size={32} className="text-[#A2CB52]" />,
                                title: "Culture First",
                                desc: "We believe happy employees deliver the best results. We prioritize work-life balance, mental health, and professional growth."
                            },
                            {
                                icon: <Zap size={32} className="text-[#A2CB52]" />,
                                title: "Cutting-Edge Tech",
                                desc: "Don't get stuck with legacy systems. Work with the latest AI tools, automation platforms, and cloud technologies."
                            },
                            {
                                icon: <Heart size={32} className="text-[#A2CB52]" />,
                                title: "Global Impact",
                                desc: "Work with exciting startups and Fortune 500 companies from around the world, right from the Philippines."
                            }
                        ].map((item, i) => (
                            <FadeIn key={i} delay={i * 0.1} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
                                <div className="mb-4">{item.icon}</div>
                                <h3 className="text-xl font-bold text-[#20222D] mb-2">{item.title}</h3>
                                <p className="text-gray-600">{item.desc}</p>
                            </FadeIn>
                        ))}
                    </div>
                </div>
            </section>

            {/* Open Positions - Placeholder for now */}
            <section className="py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-4xl mx-auto text-center">
                    <FadeIn>
                        <h2 className="text-3xl font-bold text-[#20222D] mb-8">Open Positions</h2>

                        <div className="bg-blue-50 border border-blue-100 rounded-xl p-8 mb-8">
                            <h3 className="text-xl font-bold text-blue-900 mb-2">Don't see a perfect fit?</h3>
                            <p className="text-blue-700 mb-6">
                                We're always looking for talented individuals. Send your resume to our HR team and we'll keep you on file.
                            </p>
                            <a href="mailto:info@bpoconsultants.ph" className="inline-flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg font-bold hover:bg-blue-700 transition-colors">
                                Email HR Team <ArrowRight className="ml-2" size={18} />
                            </a>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </div>
    );
};

export default Careers;
